<header class="app-header" [class.header-with-additional-btn]="showHeaderControls"
        [ngClass]="{'header-with-filter': showSearch || showSelect}">
    <div class="app-header__inner">
        <div class="step-back" *ngIf="backButtonDisplayed">
            <app-button
                    [tabindex]="6"
                    [cssClasses]="'btn slim solid__blue-02'"
                    [icon]="'arrow_back'"
                    [hideLabelMobileOnly]="true"
                    [ariaLabel]="backButtonLabel + ('GENERAL.BUTTON' | translate)"
                    (buttonClicked)="buttonEvent.emit()">
                {{backButtonLabel}}
            </app-button>
        </div>
        <div class="user-info">
            <ng-container *ngIf="selectedRoles.length > 1">
                <mat-icon class="user-info__role material-icons-round">list</mat-icon>
            </ng-container>
            <ng-container *ngIf="selectedRoles.length === 1">
                <mat-icon class="user-info__role material-icons-round" *ngFor="let role of selectedRoles" [ngClass]="{'custom-icon':this.customIcon===true}" svgIcon='{{this.customIcon===true ? iconsForOtherRoles(role) : null}}'>
                    {{this.customIcon===false ? 'person' : ''}}
                </mat-icon>
            </ng-container>
            <p class="user-info__email">{{username}}</p>
        </div>
        <div class="header-leave-button" *ngIf="leaveButton">
            <app-button
                    [ariaLabel]="leaveButtonLabel + ('GENERAL.BUTTON' | translate)"
                    [tabindex]="5"
                    [cssClasses]="'btn slim solid__gray-02'"
                    [icon]="'logout'"
                    [hideLabelMobileOnly]="true"
                    (buttonClicked)="leaveIndication.emit()">
                {{leaveButtonLabel}}
            </app-button>
        </div>
    </div>
    <div class="app-header__description-wrapper" [class.additional-btn]="showActionButton || showHeaderControls"
         [ngClass]="{'filter-section': showSearch || showSelect}">
        <div class="app-header__description-box">
            <p class="app-header__description-box__chapter-title" *ngIf="indicationTitle">{{indicationName}}</p>
            <mat-icon *ngIf="headerIcon" class="app-header__description-box__custom-icon custom-icon"
                      svgIcon='{{headerIcon}}'></mat-icon>
            <h1 class="app-header__description-box__title">{{headerText}}</h1>
            <p class="app-header__description-box__description" *ngIf="headerParagraph">{{headerParagraph}}</p>
        </div>
        <div class="app-header__button" *ngIf="showActionButton">
            <app-button
                    [disabled]="true"
                    [cssClasses]="'btn solid__gray-03'"
                    [icon]="'code'">
                {{actionButtonText}}
            </app-button>
        </div>
        <div *ngIf="showSearch || showSelect" class="app-header__filter-wrapper">
            <form *ngIf="showSearch" [formGroup]="form" class="filter-searchBox-section">
                <input matInput [formControl]="searchFormControl" (input)="onNewInput()"
                       [placeholder]="searchPlaceholder" class="input-field search" type="text" name="searchText">
                <div class="btn-wrapper reset-search" [ngClass]="showButton ? 'show-button' : ''">
                    <app-button
                            [cssClasses]="'icon solid__white'"
                            [icon]="'close'"
                            (buttonClicked)="clear()">
                    </app-button>
                </div>
            </form>
            <div #select *ngIf="showSelect" class="select-wrapper">
                <app-select-menu
                        [labelCssClasses]="'labelFontSize__fs-16'"
                        [labelWidth]="'1fr'"
                        [dropdownWidth]="'210px'"
                        [dropdownHeight]="40"
                        [labelText]="'Field'"
                        [showDeselectedOptions]="false"
                        [selectedId]="medicalFieldSelected"
                        [options]="fieldOptions"
                        (valueChangeEvent)="onSelectChange($event)">
                </app-select-menu>
            </div>
        </div>
        <div *ngIf="showHeaderControls" class="header-controls">
            <div *ngIf="showHeaderControls" class="header-tts-buttons">
                <div class="header-controls__play">
                    <app-button
                            [ariaLabel]="((ttsIconState === playState ? 'SCREEN_READER.HEADER.PLAY_BUTTON' : 'SCREEN_READER.HEADER.PAUSE_BUTTON') | translate) + ('GENERAL.BUTTON' | translate)"
                            [cssClasses]="'solid__blue-08 circle wh-80'"
                            [iconState]="ttsIconState"
                            (buttonClicked)="readText()">
                    </app-button>
                </div>
                <div class="header-controls__repeat">
                    <app-button
                            [ariaLabel]="('SCREEN_READER.HEADER.REPEAT_BUTTON' | translate) + ('GENERAL.BUTTON' | translate)"
                            [cssClasses]="'solid__blue-02 circle wh-60'"
                            [icon]="'replay'"
                            [iconColor]="'blue-10'"
                            [disabled]="repeatButtonDisabled"
                            (buttonClicked)="playFromStart()">
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</header>
